import CopyController from "./controllers/CopyController.js";
import ExpandController from "./controllers/ExpandController.js";
import SearchController from "./controllers/SearchController.js";
import SidebarController from "./controllers/SidebarController.js";
import TabsController from "./controllers/TabsController.js";
import ThemeController from "./controllers/ThemeController.js";
export default [
  { name: "CopyController", controller: CopyController },
  { name: "ExpandController", controller: ExpandController },
  { name: "SearchController", controller: SearchController },
  { name: "SidebarController", controller: SidebarController },
  { name: "TabsController", controller: TabsController },
  { name: "ThemeController", controller: ThemeController }
];